export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/v1/login",
    REGISTER: "/v1/register",
    LOGOUT: "/v1/logout",
  },
  USER: {
    PROFILE: "/v1/user/profile",
    UPDATE: "/v1/user/update",
  },
  MIGRATION: {
    CREATE: "/api/v1/migrations",
    GET_ALL: "/api/v1/migrations",
    GET_BY_ID: "/api/v1/migrations/{migration_id}",
    GET_FILE_CONTENT: "/api/v1/migrations/{migration_id}/files/{file_name}",
    POST_EXCLUDE_API: (migrationId: string, apiId: string) => `/api/v1/migrations/${migrationId}/apis/${apiId}/exclude`,
    // POST_EXCLUDE_API: "/api/v1/migrations/{migrationId}/apis/{apiId}/exclude",
  },
  MIGRATE: {
    CREATE: "/api/v1/migrate",
  },
  ASSESSMENT: {
    CREATE: "/api/v1/assessment",
  },
};
